import { useCallback } from 'react';

import { WhereClause } from '@sierralabs/query-core';

import { useApiPost } from '../../api/Api.hooks';

export type StudyParticipantQueryData<T> = T & {
  id: number;
  intendedStartDate: Date;
  completedDate: Date;
};

export interface StudyParticipantQueryParamsDto {
  entityId: string;
  columnNames: string[];
  wheres?: WhereClause[];
}

export function useQueryStudyParticipantData<T = Record<any, any>>(
  studyParticipantId: number
) {
  const { data, isLoading, error, post } = useApiPost<
    StudyParticipantQueryData<T>[][]
  >(`study-participants/${studyParticipantId}/query-data`);
  const queryData = useCallback(
    (params: StudyParticipantQueryParamsDto[]) => {
      post(params);
    },
    [post]
  );
  return {
    queryResults: data,
    loadingQuery: isLoading,
    loadingQueryError: error,
    queryData
  };
}

export function useQueryStudyParticipantDataLatest<T = Record<any, any>>(
  studyParticipantId: number
) {
  const { data, isLoading, error, post } = useApiPost<
    StudyParticipantQueryData<T>[][]
  >(`study-participants/${studyParticipantId}/query-data/latest`);
  const queryData = useCallback(
    (params: StudyParticipantQueryParamsDto[]) => {
      post(params);
    },
    [post]
  );
  return {
    queryResults: data,
    loadingQuery: isLoading,
    loadingQueryError: error,
    queryData
  };
}
